// extracted by mini-css-extract-plugin
module.exports = {"popover":"header_popover__ErzSe","dropdownContainer":"header_dropdownContainer__ECCBD","dropdownLight":"header_dropdownLight__OfnHo"};